// src/pages/Admin/Notifications/components/FilterBar.tsx

import React, { useState } from "react";
import { Grid, TextField, Button } from "@mui/material";

import { useNotification } from "../../context";
import PeriodsCalendarField from "./PeriodsCalendarField";
import RecipientMultiSelectField, {
  RecipientOption,
} from "./RecipientMultiSelectField";

const FilterBar: React.FC = () => {
  const {
    actions: { search },
    filters,
    currentTab,
  } = useNotification();

  const [id, setId] = useState(filters.id ? String(filters.id) : "");

  const [title, setTitle] = useState(filters.title || "");

  const [recipients, setRecipients] = useState<RecipientOption[]>([]);

  const [period, setPeriod] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  const handleSearch = () => {
    search({
      id: id ? Number(id) : undefined,
      title: title || undefined,
      recipient: recipients.map((item) => item.value).join(",") || undefined,
      periodStart: period[0]?.toISOString(),
      periodEnd: period[1]?.toISOString(),
      page: 1,
      status: currentTab,
    });
  };

  const handleReset = () => {
    // 1) zera estado local
    setId("");
    setTitle("");
    setRecipients([]);
    setPeriod([null, null]);

    // 2) dispara busca “limpa”
    search({
      id: undefined,
      title: undefined,
      recipient: undefined,
      periodStart: undefined,
      periodEnd: undefined,
      page: 1,
      status: currentTab,
    });
  };

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} md={2}>
        <TextField
          label="ID da notificação"
          variant="outlined"
          fullWidth
          value={id}
          onChange={(e) => setId(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Título"
          variant="outlined"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PeriodsCalendarField
          value={period}
          onChange={(newValue) => setPeriod([newValue[0], newValue[1]])}
          label="Período de vigência"
          startTitle="Período inícial da vigencia"
          endTitle="Período final da vigencia"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <RecipientMultiSelectField
          value={recipients}
          onChange={setRecipients}
          label="Destinatário"
          placeholder="Centro / Segmento / Perfil"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Grid container gap={1}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleReset}
            fullWidth
          >
            Resetar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            fullWidth
          >
            Consultar
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterBar;
